import { Camera } from "lucide-react";

export default function CameraCancelHint({ testid = "camera-cancel-hint" }) {
  return (
    <div className="flex items-start gap-1.5 text-[11px] leading-snug text-[#3A2A10]" data-testid={testid}>
      <Camera size={12} className="mt-[1px] shrink-0 opacity-70" />
      <span>
        Changed your mind in the camera? Tap <b>Cancel</b> (bottom-left on iPhone, top-left on iPad),
        or press <b>Back</b> on Android. Nothing is saved.
      </span>
    </div>
  );
}
